// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               v5.26.1
// source: atk/boundary_model.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Point2D } from "../geometry/geometry";

export const protobufPackage = "carbon.atk";

/**
 * TractorBoundaryModel represents the underlying structured data which was
 * captured and processed into the tractor's boundary polygon.  directly
 * representing this data as a data model object allows for a more
 * straightforward load/save process that doesn't need to do processing on the
 * polygon itself, and makes it easier to have frontends treat data which was
 * captured using a flow they don't understand as a black box not to be tampered
 * with.
 */
export interface TractorBoundaryModel {
  measuringTapeV1?: MeasuringTapeTractorBoundaryModelV1 | undefined;
  pointCaptureV1?: PointCaptureTractorBoundaryModelV1 | undefined;
}

/**
 * MeasuringTapeTractorBoundaryModelV1 represents the data points taken to
 * generate a tractor boundary polygon using a (metaphorical or literal)
 * "measuring tape" which can measure distances but not absolute position.
 */
export interface MeasuringTapeTractorBoundaryModelV1 {
  /**
   * the overall length of the tractor along the tractor Y axis, from farthest
   * forward to farthest rearward point
   */
  overallLengthM: number;
  /** the overall width of the tractor along the tractor X axis */
  overallWidthM: number;
  /**
   * the distance along the tractor Y axis, from the farthest forward point to
   * the midplane of the tractor front axle
   */
  yNoseToFrontAxleM: number;
  /**
   * the distance along the tractor Y axis, from the farthest forward point to
   * the front edge of the front tire
   */
  yNoseToFrontTireM?:
    | number
    | undefined;
  /**
   * the distance along the tractor X axis, from the tractor centerline to the
   * widest point forward of the front wheels
   */
  xCenterToWidestPtNoseM?: number | undefined;
}

/**
 * PointCaptureTractorBoundaryModelV1 represents the data points taken to
 * generate a tractor boundary polygon using e.g. a GPS surveying device which
 * can measure absolute positions relative to some datum.
 */
export interface PointCaptureTractorBoundaryModelV1 {
  /** the frontmost point along the tractor centerline */
  frontmost:
    | Point2D
    | undefined;
  /** the rearmost point along the tractor centerline */
  rearmost:
    | Point2D
    | undefined;
  /** the most outboard point on the left side of the tractor */
  leftExtent:
    | Point2D
    | undefined;
  /** the most outboard point on the right side of the tractor */
  rightExtent:
    | Point2D
    | undefined;
  /**
   * a point directly in front of the centerline of the right front wheel or
   * track
   */
  rightFrontTread:
    | Point2D
    | undefined;
  /**
   * a point directly in front of the centerline of the left front wheel or
   * track
   */
  leftFrontTread:
    | Point2D
    | undefined;
  /**
   * a point directly outboard of the widest part of the nose of the tractor in
   * front of the front axle
   */
  frontWidth?:
    | Point2D
    | undefined;
  /** a point directly outboard of the center of the tractor's rear axle */
  rearAxle:
    | Point2D
    | undefined;
  /** a point directly outboard of the center of the tractor's front axle */
  frontAxle: Point2D | undefined;
}

/**
 * ImplementBoundaryModel represents the underlying structured data which was
 * captured and processed into the implement's boundary polygon.  directly
 * representing this data as a data model object allows for a more
 * straightforward load/save process that doesn't need to do processing on the
 * polygon itself, and makes it easier to have frontends treat data which was
 * captured using a flow they don't understand as a black box not to be tampered
 * with.
 */
export interface ImplementBoundaryModel {
  measuringTapeV1?: MeasuringTapeImplementBoundaryModelV1 | undefined;
  pointCaptureV1?: PointCaptureImplementBoundaryModelV1 | undefined;
}

/**
 * MeasuringTapeImplementBoundaryModelV1 represents the data points taken to
 * generate an implement boundary polygon using a (metaphorical or literal)
 * "measuring tape" which can measure distances but not absolute position.
 */
export interface MeasuringTapeImplementBoundaryModelV1 {
  /**
   * the overall length along the implement Y axis, from the hitch point to the
   * farthest rearward point on the implement
   */
  overallLengthM: number;
  /**
   * the overall width of the implement along the implement X axis left of
   * the hitch point
   */
  overallWidthMLeft: number;
  /**
   * the overall width of the implement along the implement X axis right of
   * the hitch point
   */
  overallWidthMRight: number;
}

/**
 * PointCaptureImplementBoundaryModelV1 represents the data points taken to
 * generate an implement boundary polygon using e.g. a GPS surveying device
 * which can measure absolute positions relative to some datum.
 */
export interface PointCaptureImplementBoundaryModelV1 {
  /**
   * a point aligned with the hitch bar of the implement, as far back on the
   * implement as possible
   */
  hitchAligned:
    | Point2D
    | undefined;
  /**
   * a point on the frame of the implement clear of all obstructions where the
   * hitch bar connects to the frame, as close as possible to the hitch line on
   * the left side
   */
  frameConnectionLeft?:
    | Point2D
    | undefined;
  /**
   * a point on the frame of the implement clear of all obstructions where the
   * hitch bar connects to the frame, as close as possible to the hitch line on
   * the right side
   */
  frameConnectionRight?:
    | Point2D
    | undefined;
  /**
   * a point just outboard of the widest point of the working area of the
   * implement left of the hitch line
   */
  workingLeft:
    | Point2D
    | undefined;
  /**
   * a point just outboard of the widest point of the working area of the
   * implement right of the hitch line
   */
  workingRight:
    | Point2D
    | undefined;
  /**
   * a point just outboard of the widest point of the implement left of the
   * hitch line, if any non-working part of the implement protrudes outside the
   * working area along the X axis
   */
  leftmost?:
    | Point2D
    | undefined;
  /**
   * a point just outboard of the widest point of the implement right of the
   * hitch line, if any non-working part of the implement protrudes outside the
   * working area on the X axis
   */
  rightmost?:
    | Point2D
    | undefined;
  /**
   * a point as close as possible to the front plane of the working area of the
   * implement
   */
  workingFront:
    | Point2D
    | undefined;
  /**
   * a point as close as possible to the rear plane of the working area of the
   * implement
   */
  workingRear:
    | Point2D
    | undefined;
  /**
   * a point as close as possible to the rearmost point of the implement, if any
   * non-working part of the implement protrudes behind the working area
   */
  rearmost?: Point2D | undefined;
}

function createBaseTractorBoundaryModel(): TractorBoundaryModel {
  return { measuringTapeV1: undefined, pointCaptureV1: undefined };
}

export const TractorBoundaryModel: MessageFns<TractorBoundaryModel> = {
  encode(message: TractorBoundaryModel, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.measuringTapeV1 !== undefined) {
      MeasuringTapeTractorBoundaryModelV1.encode(message.measuringTapeV1, writer.uint32(10).fork()).join();
    }
    if (message.pointCaptureV1 !== undefined) {
      PointCaptureTractorBoundaryModelV1.encode(message.pointCaptureV1, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TractorBoundaryModel {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTractorBoundaryModel();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.measuringTapeV1 = MeasuringTapeTractorBoundaryModelV1.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pointCaptureV1 = PointCaptureTractorBoundaryModelV1.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TractorBoundaryModel {
    return {
      measuringTapeV1: isSet(object.measuringTapeV1)
        ? MeasuringTapeTractorBoundaryModelV1.fromJSON(object.measuringTapeV1)
        : isSet(object.measuring_tape_v1)
        ? MeasuringTapeTractorBoundaryModelV1.fromJSON(object.measuring_tape_v1)
        : undefined,
      pointCaptureV1: isSet(object.pointCaptureV1)
        ? PointCaptureTractorBoundaryModelV1.fromJSON(object.pointCaptureV1)
        : isSet(object.point_capture_v1)
        ? PointCaptureTractorBoundaryModelV1.fromJSON(object.point_capture_v1)
        : undefined,
    };
  },

  toJSON(message: TractorBoundaryModel): unknown {
    const obj: any = {};
    if (message.measuringTapeV1 !== undefined) {
      obj.measuringTapeV1 = MeasuringTapeTractorBoundaryModelV1.toJSON(message.measuringTapeV1);
    }
    if (message.pointCaptureV1 !== undefined) {
      obj.pointCaptureV1 = PointCaptureTractorBoundaryModelV1.toJSON(message.pointCaptureV1);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TractorBoundaryModel>, I>>(base?: I): TractorBoundaryModel {
    return TractorBoundaryModel.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TractorBoundaryModel>, I>>(object: I): TractorBoundaryModel {
    const message = createBaseTractorBoundaryModel();
    message.measuringTapeV1 = (object.measuringTapeV1 !== undefined && object.measuringTapeV1 !== null)
      ? MeasuringTapeTractorBoundaryModelV1.fromPartial(object.measuringTapeV1)
      : undefined;
    message.pointCaptureV1 = (object.pointCaptureV1 !== undefined && object.pointCaptureV1 !== null)
      ? PointCaptureTractorBoundaryModelV1.fromPartial(object.pointCaptureV1)
      : undefined;
    return message;
  },
};

function createBaseMeasuringTapeTractorBoundaryModelV1(): MeasuringTapeTractorBoundaryModelV1 {
  return {
    overallLengthM: 0,
    overallWidthM: 0,
    yNoseToFrontAxleM: 0,
    yNoseToFrontTireM: undefined,
    xCenterToWidestPtNoseM: undefined,
  };
}

export const MeasuringTapeTractorBoundaryModelV1: MessageFns<MeasuringTapeTractorBoundaryModelV1> = {
  encode(message: MeasuringTapeTractorBoundaryModelV1, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.overallLengthM !== 0) {
      writer.uint32(9).double(message.overallLengthM);
    }
    if (message.overallWidthM !== 0) {
      writer.uint32(17).double(message.overallWidthM);
    }
    if (message.yNoseToFrontAxleM !== 0) {
      writer.uint32(25).double(message.yNoseToFrontAxleM);
    }
    if (message.yNoseToFrontTireM !== undefined) {
      writer.uint32(33).double(message.yNoseToFrontTireM);
    }
    if (message.xCenterToWidestPtNoseM !== undefined) {
      writer.uint32(41).double(message.xCenterToWidestPtNoseM);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MeasuringTapeTractorBoundaryModelV1 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMeasuringTapeTractorBoundaryModelV1();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.overallLengthM = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.overallWidthM = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.yNoseToFrontAxleM = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.yNoseToFrontTireM = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.xCenterToWidestPtNoseM = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MeasuringTapeTractorBoundaryModelV1 {
    return {
      overallLengthM: isSet(object.overallLengthM)
        ? globalThis.Number(object.overallLengthM)
        : isSet(object.overall_length_m)
        ? globalThis.Number(object.overall_length_m)
        : 0,
      overallWidthM: isSet(object.overallWidthM)
        ? globalThis.Number(object.overallWidthM)
        : isSet(object.overall_width_m)
        ? globalThis.Number(object.overall_width_m)
        : 0,
      yNoseToFrontAxleM: isSet(object.yNoseToFrontAxleM)
        ? globalThis.Number(object.yNoseToFrontAxleM)
        : isSet(object.y_nose_to_front_axle_m)
        ? globalThis.Number(object.y_nose_to_front_axle_m)
        : 0,
      yNoseToFrontTireM: isSet(object.yNoseToFrontTireM)
        ? globalThis.Number(object.yNoseToFrontTireM)
        : isSet(object.y_nose_to_front_tire_m)
        ? globalThis.Number(object.y_nose_to_front_tire_m)
        : undefined,
      xCenterToWidestPtNoseM: isSet(object.xCenterToWidestPtNoseM)
        ? globalThis.Number(object.xCenterToWidestPtNoseM)
        : isSet(object.x_center_to_widest_pt_nose_m)
        ? globalThis.Number(object.x_center_to_widest_pt_nose_m)
        : undefined,
    };
  },

  toJSON(message: MeasuringTapeTractorBoundaryModelV1): unknown {
    const obj: any = {};
    if (message.overallLengthM !== 0) {
      obj.overallLengthM = message.overallLengthM;
    }
    if (message.overallWidthM !== 0) {
      obj.overallWidthM = message.overallWidthM;
    }
    if (message.yNoseToFrontAxleM !== 0) {
      obj.yNoseToFrontAxleM = message.yNoseToFrontAxleM;
    }
    if (message.yNoseToFrontTireM !== undefined) {
      obj.yNoseToFrontTireM = message.yNoseToFrontTireM;
    }
    if (message.xCenterToWidestPtNoseM !== undefined) {
      obj.xCenterToWidestPtNoseM = message.xCenterToWidestPtNoseM;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MeasuringTapeTractorBoundaryModelV1>, I>>(
    base?: I,
  ): MeasuringTapeTractorBoundaryModelV1 {
    return MeasuringTapeTractorBoundaryModelV1.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MeasuringTapeTractorBoundaryModelV1>, I>>(
    object: I,
  ): MeasuringTapeTractorBoundaryModelV1 {
    const message = createBaseMeasuringTapeTractorBoundaryModelV1();
    message.overallLengthM = object.overallLengthM ?? 0;
    message.overallWidthM = object.overallWidthM ?? 0;
    message.yNoseToFrontAxleM = object.yNoseToFrontAxleM ?? 0;
    message.yNoseToFrontTireM = object.yNoseToFrontTireM ?? undefined;
    message.xCenterToWidestPtNoseM = object.xCenterToWidestPtNoseM ?? undefined;
    return message;
  },
};

function createBasePointCaptureTractorBoundaryModelV1(): PointCaptureTractorBoundaryModelV1 {
  return {
    frontmost: undefined,
    rearmost: undefined,
    leftExtent: undefined,
    rightExtent: undefined,
    rightFrontTread: undefined,
    leftFrontTread: undefined,
    frontWidth: undefined,
    rearAxle: undefined,
    frontAxle: undefined,
  };
}

export const PointCaptureTractorBoundaryModelV1: MessageFns<PointCaptureTractorBoundaryModelV1> = {
  encode(message: PointCaptureTractorBoundaryModelV1, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.frontmost !== undefined) {
      Point2D.encode(message.frontmost, writer.uint32(10).fork()).join();
    }
    if (message.rearmost !== undefined) {
      Point2D.encode(message.rearmost, writer.uint32(18).fork()).join();
    }
    if (message.leftExtent !== undefined) {
      Point2D.encode(message.leftExtent, writer.uint32(26).fork()).join();
    }
    if (message.rightExtent !== undefined) {
      Point2D.encode(message.rightExtent, writer.uint32(34).fork()).join();
    }
    if (message.rightFrontTread !== undefined) {
      Point2D.encode(message.rightFrontTread, writer.uint32(42).fork()).join();
    }
    if (message.leftFrontTread !== undefined) {
      Point2D.encode(message.leftFrontTread, writer.uint32(50).fork()).join();
    }
    if (message.frontWidth !== undefined) {
      Point2D.encode(message.frontWidth, writer.uint32(58).fork()).join();
    }
    if (message.rearAxle !== undefined) {
      Point2D.encode(message.rearAxle, writer.uint32(66).fork()).join();
    }
    if (message.frontAxle !== undefined) {
      Point2D.encode(message.frontAxle, writer.uint32(74).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PointCaptureTractorBoundaryModelV1 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePointCaptureTractorBoundaryModelV1();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.frontmost = Point2D.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.rearmost = Point2D.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.leftExtent = Point2D.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.rightExtent = Point2D.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.rightFrontTread = Point2D.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.leftFrontTread = Point2D.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.frontWidth = Point2D.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.rearAxle = Point2D.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.frontAxle = Point2D.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PointCaptureTractorBoundaryModelV1 {
    return {
      frontmost: isSet(object.frontmost) ? Point2D.fromJSON(object.frontmost) : undefined,
      rearmost: isSet(object.rearmost) ? Point2D.fromJSON(object.rearmost) : undefined,
      leftExtent: isSet(object.leftExtent)
        ? Point2D.fromJSON(object.leftExtent)
        : isSet(object.left_extent)
        ? Point2D.fromJSON(object.left_extent)
        : undefined,
      rightExtent: isSet(object.rightExtent)
        ? Point2D.fromJSON(object.rightExtent)
        : isSet(object.right_extent)
        ? Point2D.fromJSON(object.right_extent)
        : undefined,
      rightFrontTread: isSet(object.rightFrontTread)
        ? Point2D.fromJSON(object.rightFrontTread)
        : isSet(object.right_front_tread)
        ? Point2D.fromJSON(object.right_front_tread)
        : undefined,
      leftFrontTread: isSet(object.leftFrontTread)
        ? Point2D.fromJSON(object.leftFrontTread)
        : isSet(object.left_front_tread)
        ? Point2D.fromJSON(object.left_front_tread)
        : undefined,
      frontWidth: isSet(object.frontWidth)
        ? Point2D.fromJSON(object.frontWidth)
        : isSet(object.front_width)
        ? Point2D.fromJSON(object.front_width)
        : undefined,
      rearAxle: isSet(object.rearAxle)
        ? Point2D.fromJSON(object.rearAxle)
        : isSet(object.rear_axle)
        ? Point2D.fromJSON(object.rear_axle)
        : undefined,
      frontAxle: isSet(object.frontAxle)
        ? Point2D.fromJSON(object.frontAxle)
        : isSet(object.front_axle)
        ? Point2D.fromJSON(object.front_axle)
        : undefined,
    };
  },

  toJSON(message: PointCaptureTractorBoundaryModelV1): unknown {
    const obj: any = {};
    if (message.frontmost !== undefined) {
      obj.frontmost = Point2D.toJSON(message.frontmost);
    }
    if (message.rearmost !== undefined) {
      obj.rearmost = Point2D.toJSON(message.rearmost);
    }
    if (message.leftExtent !== undefined) {
      obj.leftExtent = Point2D.toJSON(message.leftExtent);
    }
    if (message.rightExtent !== undefined) {
      obj.rightExtent = Point2D.toJSON(message.rightExtent);
    }
    if (message.rightFrontTread !== undefined) {
      obj.rightFrontTread = Point2D.toJSON(message.rightFrontTread);
    }
    if (message.leftFrontTread !== undefined) {
      obj.leftFrontTread = Point2D.toJSON(message.leftFrontTread);
    }
    if (message.frontWidth !== undefined) {
      obj.frontWidth = Point2D.toJSON(message.frontWidth);
    }
    if (message.rearAxle !== undefined) {
      obj.rearAxle = Point2D.toJSON(message.rearAxle);
    }
    if (message.frontAxle !== undefined) {
      obj.frontAxle = Point2D.toJSON(message.frontAxle);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PointCaptureTractorBoundaryModelV1>, I>>(
    base?: I,
  ): PointCaptureTractorBoundaryModelV1 {
    return PointCaptureTractorBoundaryModelV1.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PointCaptureTractorBoundaryModelV1>, I>>(
    object: I,
  ): PointCaptureTractorBoundaryModelV1 {
    const message = createBasePointCaptureTractorBoundaryModelV1();
    message.frontmost = (object.frontmost !== undefined && object.frontmost !== null)
      ? Point2D.fromPartial(object.frontmost)
      : undefined;
    message.rearmost = (object.rearmost !== undefined && object.rearmost !== null)
      ? Point2D.fromPartial(object.rearmost)
      : undefined;
    message.leftExtent = (object.leftExtent !== undefined && object.leftExtent !== null)
      ? Point2D.fromPartial(object.leftExtent)
      : undefined;
    message.rightExtent = (object.rightExtent !== undefined && object.rightExtent !== null)
      ? Point2D.fromPartial(object.rightExtent)
      : undefined;
    message.rightFrontTread = (object.rightFrontTread !== undefined && object.rightFrontTread !== null)
      ? Point2D.fromPartial(object.rightFrontTread)
      : undefined;
    message.leftFrontTread = (object.leftFrontTread !== undefined && object.leftFrontTread !== null)
      ? Point2D.fromPartial(object.leftFrontTread)
      : undefined;
    message.frontWidth = (object.frontWidth !== undefined && object.frontWidth !== null)
      ? Point2D.fromPartial(object.frontWidth)
      : undefined;
    message.rearAxle = (object.rearAxle !== undefined && object.rearAxle !== null)
      ? Point2D.fromPartial(object.rearAxle)
      : undefined;
    message.frontAxle = (object.frontAxle !== undefined && object.frontAxle !== null)
      ? Point2D.fromPartial(object.frontAxle)
      : undefined;
    return message;
  },
};

function createBaseImplementBoundaryModel(): ImplementBoundaryModel {
  return { measuringTapeV1: undefined, pointCaptureV1: undefined };
}

export const ImplementBoundaryModel: MessageFns<ImplementBoundaryModel> = {
  encode(message: ImplementBoundaryModel, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.measuringTapeV1 !== undefined) {
      MeasuringTapeImplementBoundaryModelV1.encode(message.measuringTapeV1, writer.uint32(10).fork()).join();
    }
    if (message.pointCaptureV1 !== undefined) {
      PointCaptureImplementBoundaryModelV1.encode(message.pointCaptureV1, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImplementBoundaryModel {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImplementBoundaryModel();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.measuringTapeV1 = MeasuringTapeImplementBoundaryModelV1.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pointCaptureV1 = PointCaptureImplementBoundaryModelV1.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ImplementBoundaryModel {
    return {
      measuringTapeV1: isSet(object.measuringTapeV1)
        ? MeasuringTapeImplementBoundaryModelV1.fromJSON(object.measuringTapeV1)
        : isSet(object.measuring_tape_v1)
        ? MeasuringTapeImplementBoundaryModelV1.fromJSON(object.measuring_tape_v1)
        : undefined,
      pointCaptureV1: isSet(object.pointCaptureV1)
        ? PointCaptureImplementBoundaryModelV1.fromJSON(object.pointCaptureV1)
        : isSet(object.point_capture_v1)
        ? PointCaptureImplementBoundaryModelV1.fromJSON(object.point_capture_v1)
        : undefined,
    };
  },

  toJSON(message: ImplementBoundaryModel): unknown {
    const obj: any = {};
    if (message.measuringTapeV1 !== undefined) {
      obj.measuringTapeV1 = MeasuringTapeImplementBoundaryModelV1.toJSON(message.measuringTapeV1);
    }
    if (message.pointCaptureV1 !== undefined) {
      obj.pointCaptureV1 = PointCaptureImplementBoundaryModelV1.toJSON(message.pointCaptureV1);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ImplementBoundaryModel>, I>>(base?: I): ImplementBoundaryModel {
    return ImplementBoundaryModel.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ImplementBoundaryModel>, I>>(object: I): ImplementBoundaryModel {
    const message = createBaseImplementBoundaryModel();
    message.measuringTapeV1 = (object.measuringTapeV1 !== undefined && object.measuringTapeV1 !== null)
      ? MeasuringTapeImplementBoundaryModelV1.fromPartial(object.measuringTapeV1)
      : undefined;
    message.pointCaptureV1 = (object.pointCaptureV1 !== undefined && object.pointCaptureV1 !== null)
      ? PointCaptureImplementBoundaryModelV1.fromPartial(object.pointCaptureV1)
      : undefined;
    return message;
  },
};

function createBaseMeasuringTapeImplementBoundaryModelV1(): MeasuringTapeImplementBoundaryModelV1 {
  return { overallLengthM: 0, overallWidthMLeft: 0, overallWidthMRight: 0 };
}

export const MeasuringTapeImplementBoundaryModelV1: MessageFns<MeasuringTapeImplementBoundaryModelV1> = {
  encode(message: MeasuringTapeImplementBoundaryModelV1, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.overallLengthM !== 0) {
      writer.uint32(9).double(message.overallLengthM);
    }
    if (message.overallWidthMLeft !== 0) {
      writer.uint32(17).double(message.overallWidthMLeft);
    }
    if (message.overallWidthMRight !== 0) {
      writer.uint32(25).double(message.overallWidthMRight);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MeasuringTapeImplementBoundaryModelV1 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMeasuringTapeImplementBoundaryModelV1();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.overallLengthM = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.overallWidthMLeft = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.overallWidthMRight = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MeasuringTapeImplementBoundaryModelV1 {
    return {
      overallLengthM: isSet(object.overallLengthM)
        ? globalThis.Number(object.overallLengthM)
        : isSet(object.overall_length_m)
        ? globalThis.Number(object.overall_length_m)
        : 0,
      overallWidthMLeft: isSet(object.overallWidthMLeft)
        ? globalThis.Number(object.overallWidthMLeft)
        : isSet(object.overall_width_m_left)
        ? globalThis.Number(object.overall_width_m_left)
        : 0,
      overallWidthMRight: isSet(object.overallWidthMRight)
        ? globalThis.Number(object.overallWidthMRight)
        : isSet(object.overall_width_m_right)
        ? globalThis.Number(object.overall_width_m_right)
        : 0,
    };
  },

  toJSON(message: MeasuringTapeImplementBoundaryModelV1): unknown {
    const obj: any = {};
    if (message.overallLengthM !== 0) {
      obj.overallLengthM = message.overallLengthM;
    }
    if (message.overallWidthMLeft !== 0) {
      obj.overallWidthMLeft = message.overallWidthMLeft;
    }
    if (message.overallWidthMRight !== 0) {
      obj.overallWidthMRight = message.overallWidthMRight;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MeasuringTapeImplementBoundaryModelV1>, I>>(
    base?: I,
  ): MeasuringTapeImplementBoundaryModelV1 {
    return MeasuringTapeImplementBoundaryModelV1.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MeasuringTapeImplementBoundaryModelV1>, I>>(
    object: I,
  ): MeasuringTapeImplementBoundaryModelV1 {
    const message = createBaseMeasuringTapeImplementBoundaryModelV1();
    message.overallLengthM = object.overallLengthM ?? 0;
    message.overallWidthMLeft = object.overallWidthMLeft ?? 0;
    message.overallWidthMRight = object.overallWidthMRight ?? 0;
    return message;
  },
};

function createBasePointCaptureImplementBoundaryModelV1(): PointCaptureImplementBoundaryModelV1 {
  return {
    hitchAligned: undefined,
    frameConnectionLeft: undefined,
    frameConnectionRight: undefined,
    workingLeft: undefined,
    workingRight: undefined,
    leftmost: undefined,
    rightmost: undefined,
    workingFront: undefined,
    workingRear: undefined,
    rearmost: undefined,
  };
}

export const PointCaptureImplementBoundaryModelV1: MessageFns<PointCaptureImplementBoundaryModelV1> = {
  encode(message: PointCaptureImplementBoundaryModelV1, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.hitchAligned !== undefined) {
      Point2D.encode(message.hitchAligned, writer.uint32(10).fork()).join();
    }
    if (message.frameConnectionLeft !== undefined) {
      Point2D.encode(message.frameConnectionLeft, writer.uint32(74).fork()).join();
    }
    if (message.frameConnectionRight !== undefined) {
      Point2D.encode(message.frameConnectionRight, writer.uint32(82).fork()).join();
    }
    if (message.workingLeft !== undefined) {
      Point2D.encode(message.workingLeft, writer.uint32(18).fork()).join();
    }
    if (message.workingRight !== undefined) {
      Point2D.encode(message.workingRight, writer.uint32(26).fork()).join();
    }
    if (message.leftmost !== undefined) {
      Point2D.encode(message.leftmost, writer.uint32(34).fork()).join();
    }
    if (message.rightmost !== undefined) {
      Point2D.encode(message.rightmost, writer.uint32(42).fork()).join();
    }
    if (message.workingFront !== undefined) {
      Point2D.encode(message.workingFront, writer.uint32(50).fork()).join();
    }
    if (message.workingRear !== undefined) {
      Point2D.encode(message.workingRear, writer.uint32(58).fork()).join();
    }
    if (message.rearmost !== undefined) {
      Point2D.encode(message.rearmost, writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PointCaptureImplementBoundaryModelV1 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePointCaptureImplementBoundaryModelV1();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.hitchAligned = Point2D.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.frameConnectionLeft = Point2D.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.frameConnectionRight = Point2D.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.workingLeft = Point2D.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.workingRight = Point2D.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.leftmost = Point2D.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.rightmost = Point2D.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.workingFront = Point2D.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.workingRear = Point2D.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.rearmost = Point2D.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PointCaptureImplementBoundaryModelV1 {
    return {
      hitchAligned: isSet(object.hitchAligned)
        ? Point2D.fromJSON(object.hitchAligned)
        : isSet(object.hitch_aligned)
        ? Point2D.fromJSON(object.hitch_aligned)
        : undefined,
      frameConnectionLeft: isSet(object.frameConnectionLeft)
        ? Point2D.fromJSON(object.frameConnectionLeft)
        : isSet(object.frame_connection_left)
        ? Point2D.fromJSON(object.frame_connection_left)
        : undefined,
      frameConnectionRight: isSet(object.frameConnectionRight)
        ? Point2D.fromJSON(object.frameConnectionRight)
        : isSet(object.frame_connection_right)
        ? Point2D.fromJSON(object.frame_connection_right)
        : undefined,
      workingLeft: isSet(object.workingLeft)
        ? Point2D.fromJSON(object.workingLeft)
        : isSet(object.working_left)
        ? Point2D.fromJSON(object.working_left)
        : undefined,
      workingRight: isSet(object.workingRight)
        ? Point2D.fromJSON(object.workingRight)
        : isSet(object.working_right)
        ? Point2D.fromJSON(object.working_right)
        : undefined,
      leftmost: isSet(object.leftmost) ? Point2D.fromJSON(object.leftmost) : undefined,
      rightmost: isSet(object.rightmost) ? Point2D.fromJSON(object.rightmost) : undefined,
      workingFront: isSet(object.workingFront)
        ? Point2D.fromJSON(object.workingFront)
        : isSet(object.working_front)
        ? Point2D.fromJSON(object.working_front)
        : undefined,
      workingRear: isSet(object.workingRear)
        ? Point2D.fromJSON(object.workingRear)
        : isSet(object.working_rear)
        ? Point2D.fromJSON(object.working_rear)
        : undefined,
      rearmost: isSet(object.rearmost) ? Point2D.fromJSON(object.rearmost) : undefined,
    };
  },

  toJSON(message: PointCaptureImplementBoundaryModelV1): unknown {
    const obj: any = {};
    if (message.hitchAligned !== undefined) {
      obj.hitchAligned = Point2D.toJSON(message.hitchAligned);
    }
    if (message.frameConnectionLeft !== undefined) {
      obj.frameConnectionLeft = Point2D.toJSON(message.frameConnectionLeft);
    }
    if (message.frameConnectionRight !== undefined) {
      obj.frameConnectionRight = Point2D.toJSON(message.frameConnectionRight);
    }
    if (message.workingLeft !== undefined) {
      obj.workingLeft = Point2D.toJSON(message.workingLeft);
    }
    if (message.workingRight !== undefined) {
      obj.workingRight = Point2D.toJSON(message.workingRight);
    }
    if (message.leftmost !== undefined) {
      obj.leftmost = Point2D.toJSON(message.leftmost);
    }
    if (message.rightmost !== undefined) {
      obj.rightmost = Point2D.toJSON(message.rightmost);
    }
    if (message.workingFront !== undefined) {
      obj.workingFront = Point2D.toJSON(message.workingFront);
    }
    if (message.workingRear !== undefined) {
      obj.workingRear = Point2D.toJSON(message.workingRear);
    }
    if (message.rearmost !== undefined) {
      obj.rearmost = Point2D.toJSON(message.rearmost);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PointCaptureImplementBoundaryModelV1>, I>>(
    base?: I,
  ): PointCaptureImplementBoundaryModelV1 {
    return PointCaptureImplementBoundaryModelV1.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PointCaptureImplementBoundaryModelV1>, I>>(
    object: I,
  ): PointCaptureImplementBoundaryModelV1 {
    const message = createBasePointCaptureImplementBoundaryModelV1();
    message.hitchAligned = (object.hitchAligned !== undefined && object.hitchAligned !== null)
      ? Point2D.fromPartial(object.hitchAligned)
      : undefined;
    message.frameConnectionLeft = (object.frameConnectionLeft !== undefined && object.frameConnectionLeft !== null)
      ? Point2D.fromPartial(object.frameConnectionLeft)
      : undefined;
    message.frameConnectionRight = (object.frameConnectionRight !== undefined && object.frameConnectionRight !== null)
      ? Point2D.fromPartial(object.frameConnectionRight)
      : undefined;
    message.workingLeft = (object.workingLeft !== undefined && object.workingLeft !== null)
      ? Point2D.fromPartial(object.workingLeft)
      : undefined;
    message.workingRight = (object.workingRight !== undefined && object.workingRight !== null)
      ? Point2D.fromPartial(object.workingRight)
      : undefined;
    message.leftmost = (object.leftmost !== undefined && object.leftmost !== null)
      ? Point2D.fromPartial(object.leftmost)
      : undefined;
    message.rightmost = (object.rightmost !== undefined && object.rightmost !== null)
      ? Point2D.fromPartial(object.rightmost)
      : undefined;
    message.workingFront = (object.workingFront !== undefined && object.workingFront !== null)
      ? Point2D.fromPartial(object.workingFront)
      : undefined;
    message.workingRear = (object.workingRear !== undefined && object.workingRear !== null)
      ? Point2D.fromPartial(object.workingRear)
      : undefined;
    message.rearmost = (object.rearmost !== undefined && object.rearmost !== null)
      ? Point2D.fromPartial(object.rearmost)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
